
import { defineComponent, PropType } from 'vue'
import { Checkbox } from '@/types/InputItems'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'

export default defineComponent({
  components: {
    CheckboxButton
  },

  props: {
    name: {
      type: String
    },
    items: {
      type: Array as PropType<Checkbox[]>
    }
  },

  setup(_, { emit }) {
    const changeCheckbox = (obj: { value: string; checked: boolean }) => {
      emit('change-checkbox', obj)
    }

    return {
      changeCheckbox
    }
  }
})
